jQuery($ => {
    class Meganav {
      constructor(element) {
        this._             = element;
        this._element      = $(element);
        this._focusableEls = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
        this._focusables   = this._element.find(this._focusableEls);
        this._column       = this._element.find('.m-meganav__column');

        this._overview           = this._element.find('.m-meganav__column--overview');
        this._overviewFocusables = this._overview.find(this._focusableEls);

        this._menu           = this._element.find('.m-meganav__column--menu');
        this._menuFocusables = this._menu.find(this._focusableEls);

        this._feature           = this._element.find('.m-meganav__column--feature');
        this._featureFocusables = this._feature.find(this._focusableEls);
        this._closeButton       = this._element.find('.m-meganav__back-link');
  
        this.init(); 
      }
   
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._overviewFocusables.on('keydown', this.handleOverviewKeydown);
        this._menu.on('keyToEdge', this.handleMenuKeyToEdge);
        this._featureFocusables.on('keydown', this.handleFeatureKeydown);

        this._closeButton.on('click', this.handleCloseButtonClick);
      }
  
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Menu Key-To-Edge
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMenuKeyToEdge = (event, direction) => {
        switch (direction) {
          case 'left':
            if (this._overview[0]) {
              this._overviewFocusables.first().focus();
            }
            this._overviewFocusables.last().focus();
            break;

          case 'right':
            if (this._feature[0]) {
              this._featureFocusables.first().focus();
            }
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Overview Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOverviewKeydown = event => {
        const index = this._overviewFocusables.index(event.currentTarget);

        switch (event.key) {
          case 'ArrowRight':
            const $focusable = this._menuFocusables[0]
              ? this._menuFocusables.first()
              : this._featureFocusables[0]
                ? this._featureFocusables.first()
                : null;
            
            if (!$focusable) return;
            
            event.preventDefault();
            $focusable.focus();
            break;

          case 'ArrowUp':
            event.preventDefault();
            
            const prevIndex = index - 1;

            if (prevIndex >= 0) {
              this._overviewFocusables.eq(prevIndex).focus();
            } else {
              this._overviewFocusables.last().focus();
            }

            break;

          case 'ArrowDown':
            event.preventDefault();

            const nextIndex = index + 1;

            if (nextIndex <= this._overviewFocusables.length - 1) {
              this._overviewFocusables.eq(nextIndex).focus();
            } else {
              this._overviewFocusables.first().focus();
            }

            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Feature Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleFeatureKeydown = event => {
        const index = this._featureFocusables.index(event.currentTarget);

        switch (event.key) {
          case 'ArrowLeft':
            const $focusable = this._menuFocusables[0]
              ? this._menuFocusables.last()
              : this._overviewFocusables[0]
                ? this._overviewFocusables.last()
                : null;
            
            if (!$focusable) return;
            
            event.preventDefault();
            $focusable.focus();
            break;

          case 'ArrowUp':
            event.preventDefault();
            
            const prevIndex = index - 1;

            if (prevIndex >= 0) {
              this._featureFocusables.eq(prevIndex).focus();
            } else {
              this._featureFocusables.last().focus();
            }

            break;

          case 'ArrowDown':
            event.preventDefault();

            const nextIndex = index + 1;

            if (nextIndex <= this._featureFocusables.length - 1) {
              this._featureFocusables.eq(nextIndex).focus();
            } else {
              this._featureFocusables.first().focus();
            }

            break;
        }
      }
       
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Close Button Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleCloseButtonClick = event => {
        var button           = $(event.currentTarget),
            meganav          = button.parent().parent(),
            meganavTriggerID = meganav.data('controlledby'),
            meganavTrigger   = $('#' + meganavTriggerID);

          meganavTrigger.meganav_trigger('handleMeganavClose');
      } 
    } 
 
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.meganav = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].meganav = new Meganav(_[i], opt);
        else
          ret = _[i].meganav[opt].apply(_[i].meganav, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-meganav').meganav();
});